import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'Nuovo prodotto',
  tabs: {
    [Tab.General]: 'Generale',
    [Tab.NutritionInfo]: 'Info nutrizionali',
  },
  form: {
    categories: {
      label: 'Categorie',
    },
    printer: {
      label: 'Stampante',
    },
    name: {
      label: 'Nome',
      placeholder: 'Cheeseburger',
    },
    description: {
      label: 'Descrizione',
      placeholder: '180g di polpetta di manzo, insalata, pomodori, cetrioli, jalapeños e salsa yuppi',
    },
    external_id: {
      label: 'Rif. {{integration}}',
      placeholder: 'es. riferimento SKU HubRise',
      read_only_hint: "Modificabile solo con un'integrazione HubRise connessa e sincronizzazione menu disattivata.",
    },
    price: {
      label: 'Prezzo base',
    },
    has_smart_pricing: {
      label: 'Prezzi speciali per ritiro e consegna',
    },
    pickup_price: {
      label: 'Prezzo ritiro',
      placeholder: 'Non specificato',
    },
    delivery_price: {
      label: 'Prezzo consegna',
      placeholder: 'Non specificato',
    },
    image: {
      label: 'Immagine (opzionale)',
    },
    has_combo_tax: {
      label: 'Ha tassa combo',
    },
    is_available: {
      label: 'Disponibile',
      subtitle: 'Visualizzato nel menu',
    },
    is_visible: {
      label: 'Visibile',
      title: 'Visibile nel menu',
      subtitle_on: 'I clienti possono vedere questo articolo',
      subtitle_off: 'Nascosto a tutti i clienti',
    },
    is_available_for_pickup: {
      label: 'Disponibile per il ritiro',
      subtitle_on: 'I clienti possono ordinare per il ritiro',
      subtitle_off: 'Nascosto dal menu ritiro',
    },
    is_available_for_delivery: {
      label: 'Disponibile per la consegna',
      subtitle_on: 'I clienti possono ordinare per la consegna',
      subtitle_off: 'Nascosto dal menu consegna',
    },
    modifiers: {
      label: 'Modificatori',
    },
  },
  labels: {
    smart_pricing_update_warning:
      'Aggiornando, tutte le regole di smart pricing esistenti per questo prodotto verranno riscritte.',
    smart_pricing_remove_warning:
      'Dopo il salvataggio, tutte le regole di smart pricing esistenti per questo prodotto verranno rimosse.',
  },
  availability: {
    title: 'Disponibilità',
    helper:
      "La visibilità è l'interruttore principale. Disattiva un canale per nascondere l'articolo ai clienti ritiro o consegna senza rimuoverlo dal menu.",
    status: {
      both: 'Entrambi i canali',
      pickup_only: 'Solo ritiro',
      delivery_only: 'Solo consegna',
      hidden: 'Nascosto',
      no_channels: 'Nessun canale',
    },
    warning: {
      no_channels: 'Questo articolo è visibile ma non disponibile su nessun canale — i clienti non potranno ordinarlo.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Solo ritiro',
      delivery_only: 'Solo consegna',
      no_channels: 'Nessun canale',
    },
  },
  buttons: {
    save: 'Salva',
    close: 'Chiudi',
  },
  toasts: {
    changes_got_saved: 'Le modifiche sono state salvate con successo!',
  },
};
